import script from "./CargCaMan.vue?vue&type=script&lang=ts&setup=true"
export * from "./CargCaMan.vue?vue&type=script&lang=ts&setup=true"

import "./CargCaMan.vue?vue&type=style&index=0&id=ed713d42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed713d42"]])

export default __exports__